import React from "react";
import {Link} from "react-router-dom";

import ReactTable from "react-table";
import {Button} from "reactstrap";

import API from "@beardeddevops/react.api";
import Framework from "@beardeddevops/react.framework";
import Types from "constants/Types";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Edit from '@material-ui/icons/Edit'


export default class Locations extends Framework.Components.Collection {
	constructor(props) {
		let model = new API.BuildClass(Types.Customers_Locations._name, API.RequestType.READ_ALL);
		super(props, model);
		this.state.limit = 16;
	};

	render() {
		const {data, pages, limit, loading} = this.state;
		const columns =[
			{
				Header: "Name",
				accessor: "name",
				Cell: props => <Link
					to={"/locations/" + props.original.pkey}>{props.value}</Link>
			},
			{
				Header: "Display Name",
				accessor: "name_display",
			},
			{
				Header: "Address",
				accessor: "street_1",
			},
			{
				Header: "City",
				accessor: "city",
			},
			{
				Header: "State",
				accessor: "state",
			},
			{
				Header: "FFL #",
				accessor: "ffl",
			},
			//TODO: status is subscription name
			{
				Header: "Status",
				accessor: 'description',
			},
			{
				Header: "",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 45,
				Cell: props => {
					return (
						<span>
							<Link to={"/locations/" + props.original.pkey}>
								<Button color="green-meadow" size={"sm"} block={true}>
									<Edit fontSize={'small'}/></Button>
							</Link>
						</span>
					);
				}
			},
		]

		return (
			<Card>
				<CardContent>
					<div className="table-bar">
						<div className="d-flex">
							{this.renderSearch('Locations')}
							{this.renderHeaderRight("Locations", columns)}
						</div>
					</div>

					<ReactTable
						key={this.state.key}
						columns={columns}
						manual // Forces table not to paginate or sort automatically, so we can handle it server-side
						data={data}
						pages={pages} // Display the total number of pages
						loading={loading} // Display the loading overlay when we need it
						loadingText="Requesting Data"
						onFetchData={this.fetchData} // Request new data when things change
						defaultSorted={[
							{
								id: this.model.sort,
								desc: this.model.order === 'desc'
							}
						]}
						showPagination={true}
						defaultPageSize={limit}
						className="-striped -highlight"
						onPageSizeChange={this.onPageSizeChange}
						pageSize={limit}
					/>


					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}
